import { NocfoTheme } from '../styled'
import nocfoTheme from './nocfo'

const theme: NocfoTheme = {
  ...nocfoTheme,
  brandUrl: 'https://www.kiva360.fi',
  colors: {
    ...nocfoTheme.colors,
    neutralBlack: '#0f1e32',
    neutralGray: '#f4f7fa',
    primary: '#0788c9',
    info: '#0788c9',
    success: '#2ca945',
    error: '#dc2626',
    warning: '#e08a00',
    AIPurple: '#7c5bff',
    menuBg: '#0f1e32',
    backdrop: '#0f1e3266',
    dashboardExtra1: '#72c44a',
    dashboardExtra2: '#0788c9',
    ifBlue: '#056a9d',
    kraviaOrange: '#ff5e29'
  },
  assets: {
    logo: 'https://cdn.nocfo.io/third-party/kiva360/logo-basic.png',
    logoLight: 'https://cdn.nocfo.io/third-party/kiva360/logo-light.png',
    menuLogo: {
      height: '40px',
      maxWidth: '180px'
    }
  }
}

export default theme
